import React from 'react';

// Base skeleton component with shimmer effect
export const Skeleton = ({ variant = 'rect', width, height, style, className = '' }) => {
  const variantClass = `skeleton-${variant}`;
  
  return (
    <div 
      className={`skeleton ${variantClass} ${className}`}
      style={{
        width: width || '100%',
        height: height || '20px',
        ...style
      }}
    />
  );
};

// Card skeleton with multiple elements
export const SkeletonCard = ({ children, className = '' }) => {
  return (
    <div className={`skeleton-card ${className}`}>
      {children}
    </div>
  );
};

// Text skeleton
export const SkeletonText = ({ lines = 1, className = '' }) => {
  return (
    <div className={`skeleton-text ${className}`}>
      {[...Array(lines)].map((_, index) => (
        <Skeleton 
          key={index} 
          height="16px" 
          style={{ 
            marginBottom: index < lines - 1 ? '8px' : '0',
            width: index === lines - 1 ? '80%' : '100%'
          }} 
        />
      ))}
    </div>
  );
};

export default Skeleton;

